import { createErrorHandler } from '../base';
import { aaCheckoutErrorConfig } from './error-config';
import i18n from '@/helper/i18n';

const t = i18n.chain;

export { aaCheckoutErrorConfig };
export const handleAACheckoutError = createErrorHandler(aaCheckoutErrorConfig);
